import React from 'react';
import {createRoot, Root} from 'react-dom/client';
import App from "./tsx/App";
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import {createManager} from "./ts/manager/Manager";
import {managerConfig} from "./ts/manager/ManagerConfig";
import {createModelFactory, getModelFactory} from "./ts/model-factory/ModelFactory";
import {modelFactoryConfig} from "./ts/model-factory/config/ModelFactoryConfig";

defineCustomElements(window).then(_ => {});
const container: HTMLElement | null = document.getElementById('root');
const root: Root = createRoot(container!);
const manager = createManager(managerConfig);

manager.app.init();

createModelFactory(modelFactoryConfig);

getModelFactory().requireInitialModels();

root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);